import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import UiKit from 'components/UiKit';
import useStore from 'utils/hooks/useStore';
import { ReactComponent as RRLogo } from 'images/rr-logo.svg';
import { ReactComponent as SSLogo } from 'images/ss-logo.svg';

export default function PoweredBy({ className = '' }) {
  const { isSSRStore, getStoreProperty } = useStore();

  const isVisible = getStoreProperty('aspencx_branding.visible');
  const link = getStoreProperty('aspencx_branding.link');
  const Logo = isSSRStore ? SSLogo : RRLogo;
  const logoType = isSSRStore ? 'ss' : 'rr';

  if (!isVisible) {
    return null;
  }

  return (
    <UiKit.Flex
      align="center"
      justify="center"
      className={cn(styles.container, className)}
      data-type={logoType}
    >
      <a
        className={styles.link}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <UiKit.Text>Powered By</UiKit.Text>
        <Logo className={styles.logo} />
      </a>
    </UiKit.Flex>
  );
}
